import { useEffect, useRef } from "react";

export default function WhatsAppSection() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("opacity-100", "scale-100");
          entry.target.classList.remove("opacity-0", "scale-95");
        }
      },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="py-14 md:py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div
          ref={ref}
          className="opacity-0 scale-95 transition-all duration-700 bg-[#1B2A4A] rounded-2xl p-8 md:p-12 flex flex-col md:flex-row items-center gap-8 md:gap-12"
        >
          <div className="flex-shrink-0">
            <div className="w-24 h-24 flex items-center justify-center bg-[#7FBF3F]/20 rounded-full border-2 border-[#7FBF3F]/30">
              <i className="ri-whatsapp-line text-5xl text-[#7FBF3F]"></i>
            </div>
          </div>

          <div className="flex-1 text-center md:text-left">
            <div className="inline-flex items-center gap-2 bg-[#7FBF3F]/20 text-[#7FBF3F] text-xs font-semibold px-4 py-1.5 rounded-full mb-4 uppercase tracking-wider">
              <i className="ri-flashlight-line"></i>Fastest Way to Reach Us
            </div>
            <h2 className="font-serif text-2xl md:text-3xl font-bold text-white mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
              Need Quick Project Details or a Site Visit?
            </h2>
            <p className="text-white/70 text-sm md:text-base leading-relaxed mb-6 max-w-xl">
              Chat with us on WhatsApp for instant project information, pricing, availability, and to book your site visit. Our team responds quickly during working hours.
            </p>
            <div className="flex flex-wrap gap-3 justify-center md:justify-start">
              <a href="https://wa.me/919945124133?text=Hi%2C%20I%20am%20interested%20in%20your%20residential%20projects%20in%20Bengaluru.%20Please%20share%20details." target="_blank" rel="nofollow noreferrer" className="inline-flex items-center gap-2.5 bg-[#7FBF3F] hover:bg-[#6aaa32] text-white font-bold text-sm px-8 py-3.5 rounded-xl transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-whatsapp-line text-lg"></i>Chat on WhatsApp
              </a>
              <a href="tel:+919945124133" className="inline-flex items-center gap-2 border border-white/30 hover:border-white text-white font-semibold text-sm px-6 py-3.5 rounded-xl transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-phone-line"></i>Call Instead
              </a>
            </div>
          </div>

          <div className="flex-shrink-0 grid grid-cols-2 gap-4 md:gap-5">
            {[
              { value: "< 1 hr", label: "Avg. Response" },
              { value: "Mon–Sat", label: "Available" },
              { value: "100%", label: "Free Advice" },
              { value: "10+", label: "Years Local" },
            ].map((stat) => (
              <div key={stat.label} className="bg-white/10 rounded-xl p-4 text-center">
                <div className="font-serif text-xl font-bold text-white mb-1" style={{ fontFamily: "'Playfair Display', serif" }}>{stat.value}</div>
                <div className="text-white/60 text-xs">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
